/* Copyright (c) 2020 Paul Nebel */

import { Machine, assign } from 'xstate';

const increment = assign({
    previousIndex: context => context.index,
    index: context => (context.index < (context.length - 1)) ? context.index + 1 : context.index,
});
const decrement = assign({
    previousIndex: context => context.index,
    index: context => (context.index > 0) ? context.index - 1 : context.index,
});
const goToStart = assign({
    previousIndex: context => context.index,
    index: () => 0,
});
const goToEnd = assign({
    previousIndex: context => context.index,
    index: context => context.length - 1,
});
const setIndex = assign({
    previousIndex: (context, event) => (event.chordIndex < context.length) ? context.index : context.previousIndex,
    index: (context, event) => (event.chordIndex < context.length) ? event.chordIndex : context.index,
});
const setRepeat = assign({
    repeat: (context, event) => event.toggleState,
});

const createPlayHeadMachine = (length = 1) => {
    return Machine(
        {
            id: 'playHead',
            initial: 'active',
            context: {
                previousIndex: (length > 0) ? 0 : -1,
                index: (length > 0) ? 0 : -1,
                length,
                repeat: true,
            },
            states: {
                active: {
                    on: {
                        NEXT: { actions: 'increment' },
                        PREV: { actions: 'decrement' },
                        FIRST: { actions: 'goToStart' },
                        LAST: { actions: 'goToEnd' },
                        SET_INDEX: { actions: 'setIndex' },
                        SET_REPEAT: { actions: 'setRepeat' },
                    }
                },
            }
        },
        {
            actions: {
                increment,
                decrement,
                goToStart,
                goToEnd,
                setIndex,
                setRepeat,
            },
        },
    );
};

export default createPlayHeadMachine;